import React from 'react'
import laptop from '../assets/laptop.jpg';
import axios from 'axios';


function Experts() {

  const getApiData = async () => {
    axios.get("https://jsonplaceholder.typicode.com/todos/1")
      .then((res) => {
        console.log(res.data);
      }).catch((err) => {
        console.log(`Error : ${err}`);
      })
  }

  return (
    <div className='max-w-[1250px] p-2 mx-auto md:grid grid-cols-2 my-10'>
      <div className='col-span-1 md:w-[80%] text-center'>
        <img className='object-cover' src={laptop} alt="Laptop" />
      </div>
      <div className='col-span-1 flex flex-col justify-center px-3 md:px-0'>
        <h1 className='font-bold my-2 uppercase text-2xl text-[#00df9a]'>learn from experts</h1>
        <p className='text-justify my-2'>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dolore expedita ad et harum perferendis minus fuga doloribus eos impedit vel nam cumque consequatur sequi odit aliquid totam, ratione officiis exercitationem.</p>
        <button onClick={getApiData} className='bg-black text-white p-3 rounded md:w-[30%] my-2'>Get Started</button>
      </div>
    </div>
  )
}

export default Experts